<template>
	<div class="payment_term_container">
		<ul class="payment_term_wrapper">
			<li v-for="(option, index) in termOptions" :key="option.title">
				<div class="body_8_M" @click="() => toggleTermList(index)">
					{{ option.title }}
					<img :class="`${option.isOpen ? '' : 'close_term_list'}`"
						src="/static/icons/arrow/arrow_small_bold_right.svg" />
				</div>
				<ul v-if="option.isOpen">
					<li v-for="term in option.list" :key="term.title" class="body_10 f_gray_4">
						{{ term.title }}
						<a @click="()=>handleTermModalOpen(term)">보기</a>
					</li>
				</ul>
			</li>
		</ul>
		<div class="agree_paragraph body_10">
			위 주문 내용을 확인하였으며,<br />회원 본인은 개인정보 이용 및 제공,
			결제에 동의합니다.
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
export default {
	props: {
		onClickTermModalOpen:{
			type: Function
		}
	},
	data() {
		return {
			termOptions: [
				{
					title: '구매조건 확인 및 결제대행 서비스 약관 동의',
					isOpen: true,
					list: []
				},
				{
					title: '서비스 약관 동의',
					isOpen: true,
					list: []
				}
			]
		}
	},
	mounted(){
		this.getTermsList1()
		this.getTermsList2()
	},
	methods: {
		toggleTermList(index) {
			this.termOptions[index].isOpen = !this.termOptions[index].isOpen
		},
		handleTermModalOpen(index){
			this.onClickTermModalOpen(index);
		},
		async getTermsList1(){
			var $this = this;
			Vue.httpClient
			.post('/m/ai/term/list', {termType:30})
			.then(response => {
				if(response.data.status=='200'){
					var result = response.data.result
					if(result){
						result.forEach((item)=>{
							let pushitem={}
							pushitem.title = item.title
							pushitem.content = item.contents
							$this.termOptions[0].list.push(pushitem)
						})
					}
				}
			})
		},
		async getTermsList2(){
			var $this = this;
			Vue.httpClient
			.post('/m/ai/term/list', {termType:40})
			.then(response => {
				if(response.data.status=='200'){
					var result = response.data.result
					if(result){
						result.forEach((item)=>{
							let pushitem={}
							pushitem.title = item.title
							pushitem.content = item.contents
							$this.termOptions[1].list.push(pushitem)
						})
					}
				}
			})
		}
	}
}
</script>

<style scoped>
.payment_term_container {
	padding: 20px;
}

.payment_term_wrapper>li {
	margin-bottom: 12px;
}

.payment_term_wrapper>li>div {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.payment_term_wrapper>li>ul {
	margin: 12px 0 0;
	display: grid;
	gap: 8px;
}

.payment_term_wrapper>li>ul>li {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.payment_term_wrapper>li>div>img {
	transition: 0.3s;
	transform: rotate(-90deg);
}

.payment_term_wrapper>li>div>.close_term_list {
	transform: rotate(90deg);
}

.agree_paragraph {
	text-align: center;
	margin-top: 16px;
	padding-top: 16px;
	border-top: 1px solid var(--gray-scale-9);
}
</style>



// WEBPACK FOOTER //
// src/components/ai/PaymentTermList.vue